import {
  KeyRoundIcon,
  SettingsIcon,
  Share2Icon,
  UsersIcon,
  UserIcon,
  WebhookIcon,
  BotIcon,
  ChartNoAxesCombined,
  Sparkle,
  CircleDollarSign
} from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link, useParams } from 'react-router-dom'
import { isFeatureAvailable } from '../../../../lib'
import clsx from 'clsx'

type DrawerSettingsItem = {
  title: string
  icon: typeof SettingsIcon
  to: string
  hidden?: boolean
  subItems?: {
    title: string
    icon: typeof SettingsIcon
    to: string
  } []
}

const drawerSettingsItems: DrawerSettingsItem[] = [
  {
    title: 'Workspace',
    icon: SettingsIcon,
    to: 'settings'
  },
  {
    title: 'Members',
    icon: UserIcon,
    to: 'members'
  },
  {
    title: 'Groups',
    icon: UsersIcon,
    to: 'groups'
  },
  {
    title: 'Assistant',
    icon: BotIcon,
    to: 'assistant',
    hidden: !isFeatureAvailable('cogfy-assistant')
  },
  {
    title: 'Connections',
    icon: Share2Icon,
    to: 'connections'
  },
  {
    title: 'API Keys',
    icon: KeyRoundIcon,
    to: 'api-keys'
  },
  {
    title: 'Webhooks',
    icon: WebhookIcon,
    to: 'webhooks'
  },
  {
    title: 'Usage',
    icon: ChartNoAxesCombined,
    to: 'usage/overview',
    subItems: [
      {
        title: 'Tasks',
        icon: Sparkle,
        to: 'usage/tasks'
      },
      {
        title: 'Credits',
        icon: CircleDollarSign,
        to: 'usage/credits'
      },
      {
        title: 'Connections',
        icon: Share2Icon,
        to: 'usage/connections'
      }
    ]
  }
].filter(item => !item.hidden)

export type SettingsDrawerItemsProps = {
  workspace: string
}

export function SettingsDrawerItems (props: SettingsDrawerItemsProps) {
  const { workspace } = props
  const { t } = useTranslation()
  const params = useParams()

  return (
    <ul className="menu w-full p-0">
      {drawerSettingsItems.map(item => (
        <>
          <li key={item.title} className="px-1">
            <Link to={`/${workspace}/${item.to}`} className={clsx(params['*'] === item.to && 'bg-base-200')}>
              <item.icon size={16} /> {t(item.title)}
            </Link>
          </li>
          <>
            {item.subItems?.map(item => (
              <li key={item.title} className="px-4">
                <Link to={`/${workspace}/${item.to}`} className={clsx(params['*'] === item.to && 'bg-base-200')}>
                  <item.icon size={16} /> {t(item.title)}
                </Link>
              </li>
            ))}
          </>
        </>
      ))}
    </ul>
  )
}
